import { Reducer, SliceCaseReducers } from "@reduxjs/toolkit";

import { fetchSystemInfoByIdThunk } from "../../../Store/Thunks/systemInfoByIds";
import { System } from "../..";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { RootState } from "../../../Store";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { AsyncEntityState } from "../../../Store/Thunks/asyncEntityStateUtil";


// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice<System, number, SliceCaseReducers<AsyncEntityState<System, number>>,System>({
  name: "systems",
  reducers: {
    },
  fetchByIdsThunk: fetchSystemInfoByIdThunk,
  selectId:(system) => system.system_id
})

export const systemInfoReducer = reducer as Reducer<AsyncEntityState<System, number>>;

const selectState = (state: RootState) => state.graphQlData.systems;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectSystemInfoById, selectAll: SelectAllSystemInfos} = entityAdapter.getSelectors(selectState);

const systemInfoByIdFetcher = new EnqueueFetcher(fetchSystemInfoByIdThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)


const selectLoadingIds = getSelectors(selectState).selectLoadingIds;
export const useSystemInfoById = entityByIdWithStatusHookFactory<System, number>(systemInfoByIdFetcher.enqueueFetchById, selectSystemInfoById, selectLoadingIds )
